// 设置主管
<template>
  <el-dialog
    title="设置主管"
    :visible="visibleDialogSetManager"
    :before-close="visiClose"
    width="800px"
  >
    <el-row :gutter="20">
      <el-col
        :span="24"
        style="margin-top: -15px; padding-right: 0; text-align: end"
      >
        <el-form :inline="true" :model="setManagerFilters" size="small">
          <el-form-item>
            <el-input
              v-model="setManagerFilters.keyword"
              placeholder="姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleClickSearchManager">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- table -->
      <el-col :span="24" style="margin-top: -15px" class="custom-table-style">
        <el-table
          :data="tableSetManager"
          style="width: 100%; border: 1px solid #cbcbcb; border-bottom: 0"
          tooltip-effect="dark"
          @row-click="handleClickRow"
          highlight-current-row
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '600',
          }"
        >
          <el-table-column label="姓名/企业名称" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.userName }}
              <span v-if="scope.row.targetId != ''">{{
                `(${scope.row.targetId})`
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="部门"
            prop="groupNames"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <span v-show="selectCorpUserId === scope.row.corpUserId">
                <img src="/images/check.png" alt="" width="25" />
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!-- pagination -->
      <el-col :span="24" style="padding: 30px 0; position: relative" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="setManagerFilters.itemPage"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="setManagerFilters.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="setManagerFilters.pageTotal"
        />
        <el-go
          :page-size="setManagerFilters.pageSize"
          :total="setManagerFilters.pageTotal"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancelManager" style="color: #ec1c1c"
        >移除当前部门主管</el-button
      >
      <el-button size="mini" @click="visiClose">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleClickSetManagerOk()"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
// components
import ElGo from "@/components/go/Go.vue";
// API
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";

export default {
  props: { visibleDialogSetManager: Boolean, selectCorpGroupId: Number },
  components: { ElGo },
  data () {
    // 这里存放数据
    return {
      selectCorpUserId: undefined, // select user id
      tableSetManager: [],
      setManagerFilters: {
        keyword: "",
        itemPage: 1,
        pageSize: 5,
        pageTotal: 0,
        corpGroupId: ""
      },
    }
  },
  // 方法集合
  methods: {
    /** 取消主管 */
    cancelManager () {
      const _this = this
      if (this.selectCorpUserId === undefined || true) {
        // this.$message.error("请选择要设置的主管");
        // return;
        this.$confirm("是否清空原主管", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            _this.handleClickSetManagerOk(1, 'delete')
          })
          .catch(() => { });
      }
    },
    /** 确认 */
    handleClickSetManagerOk (cancel, deleteVal) {
      if (!cancel && this.selectCorpUserId === undefined) {
        this.$message.error("请选择要设置的主管");
        return;
      }
      let params = {};
      params.corpUserId = this.selectCorpUserId;
      params.corpGroupId = this.selectCorpGroupId;
      ApiCorpMethods.OrganizationController.setGroupMan(deleteVal ? {corpGroupId: this.selectCorpGroupId} : params)
        .then(res => {
          if (res.success) {
            this.$message.success(res.description)
            this.visiClose()
            this.$emit('refresh') //刷新数据
          } else if (res.code === '10802') {
            this.$message.error(`暂无该部门的权限，如需使用，请联系管理员修改权限范围`);
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    /** 关闭弹窗 */
    visiClose () {
      this.$emit('update:visibleDialogSetManager', false)
    },
    /** 每页条数change */
    handleCurrentChange (val) {
      this.setManagerFilters.itemPage = val;
      this.queryTool();
    },
    /** 分页 */
    handleSizeChange (val) {
      this.setManagerFilters.itemPage = 1;
      this.setManagerFilters.pageSize = val;
      this.queryTool();
    },
    /** 行点击 */
    handleClickRow (row) {
      if(row.identityAuth !==1) return this.$message.warning('当前成员未实名，不能设置为部门主管')
      this.selectCorpUserId = row.corpUserId;
    },
    /** 获取数据 */
    queryTool () {
      this.selectCorpUserId = undefined;
      this.setManagerFilters.targetId = this.setManagerFilters.keyword;
      // this.setManagerFilters.corpGroupId = this.selectCorpGroupId;
      ApiCorpMethods.OrganizationController.listCorpUsers(
        this.setManagerFilters
      )
        .then(res => {
          if (res.code === "0") {
            this.tableSetManager = res.data;
            this.setManagerFilters.pageTotal = res.total;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    /** 查询 */
    handleClickSearchManager () {
      this.queryTool();
    },
    /** 重置 */
    reset () {
      this.setManagerFilters = {
        keyword: "",
        itemPage: 1,
        pageSize: 5,
        pageTotal: 0,
        corpGroupId: ""
      };
      this.handleClickSearchManager();
    },
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    visibleDialogSetManager (newVal) {
      if (newVal) this.reset()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
  },
}
</script>

<style lang='less' scoped>
.active-item {
  margin-right: 10px;
  color: rgb(236, 28, 28);
  font-size: 22px;
  font-weight: bold;
}
/* // @import url(); 引入公共css类 */
</style>



// WEBPACK FOOTER //
// components/console/memberManage/components/supervisor.vue